import React from 'react'

const Team = () => {
    return (
        <div>
            <section className="pt-120 pb-70 section-pattern">
  <div className="container">

  <div className="row">
  <div className="col-12">
    {/* Section Title Begin */}
    <div className="section-title text-center mb-5">
    
      <h2>Our Team</h2>
      <br/>
      <p>With a highly qualified, experienced and dedicated team, we build new horizons giving a ‘wow’ feel to you and your stakeholders. <br/> 
      Our team meets the requirement of every client. We have a pool of talented people, who are <br/>expert in different segments of the market.

</p>
    </div>
    {/* Section Title End */}
  </div>
</div>

   
    <div className="row">
      <div className="col-lg-3 col-sm-6">
        {/* Single Team Begin */}
        <div className="single-team-member">
          {/* Team Image Begin */}
          <div className="image position-relative">
            <img src="././img/Akif.jpg" alt="" />
          </div>
          {/* Team Image End */}
          {/* Team Info Begin */}
          <div className="team-info">
            <div className="info-front text-center">
              <h4>Akif M Sheikh</h4>
              <p>Founder & CEO
</p>
            </div>
            <div className="info-back">
              <ul className="social_icon_list list-inline text-center w-100 d-flex justify-content-around">
                <li>
                  <a href="#"><i className="fab fa-facebook" aria-hidden="true" /></a>
                </li>
                <li>
                  <a href="#"><i className="fab fa-twitter" aria-hidden="true" /></a>
                </li>
                <li>
                  <a href="#"><i className="fab fa-linkedin" aria-hidden="true" /></a>
                </li>
              
              </ul>
            </div>
          </div>
          {/* Team Info End */}
        </div>
        {/* Single Team End */}
      </div>
      <div className="col-lg-3 col-sm-6">
        {/* Single Team Begin */}
        <div className="single-team-member">
          {/* Team Image Begin */}
          <div className="image position-relative">
            <img src="././img/Ozair.jpg" alt="" />
          </div>
          {/* Team Image End */}
          {/* Team Info Begin */}
          <div className="team-info">
            <div className="info-front text-center">
              <h4>Ozair Qadir
</h4>
              <p>Business Growth Officer

</p>
            </div>
            <div className="info-back">
              <ul className="social_icon_list list-inline text-center w-100 d-flex justify-content-around">
                <li>
                  <a href="#"><i className="fab fa-facebook" aria-hidden="true" /></a>
                </li>
                <li>
                  <a href="#"><i className="fab fa-twitter" aria-hidden="true" /></a>
                </li>
                <li>
                  <a href="#"><i className="fab fa-linkedin" aria-hidden="true" /></a>
                </li>
              
              </ul>
            </div>
          </div>
          {/* Team Info End */}
        </div>
        {/* Single Team End */}
      </div>
      <div className="col-lg-3 col-sm-6">
        {/* Single Team Begin */}
        <div className="single-team-member">
          {/* Team Image Begin */}
          <div className="image position-relative">
            <img src="././img/Imran.jpg" alt="" />
          </div>
          {/* Team Image End */}
          {/* Team Info Begin */}
          <div className="team-info">
            <div className="info-front text-center">
              <h4>Imran Siddiqui
</h4>
              <p>COO

</p>
            </div>
            <div className="info-back">
              <ul className="social_icon_list list-inline text-center w-100 d-flex justify-content-around">
                <li>
                  <a href="#"><i className="fab fa-facebook" aria-hidden="true" /></a>
                </li>
                <li>
                  <a href="#"><i className="fab fa-twitter" aria-hidden="true" /></a>
                </li>
                <li>
                  <a href="#"><i className="fab fa-linkedin" aria-hidden="true" /></a>
                </li>
              
              </ul>
            </div>
          </div>
          {/* Team Info End */}
        </div>
        {/* Single Team End */}
      </div>
      <div className="col-lg-3 col-sm-6">
        {/* Single Team Begin */}
        <div className="single-team-member">
          {/* Team Image Begin */}
          <div className="image position-relative">
            <img src="././img/Nadir.jpg" alt="" />
          </div>
          {/* Team Image End */}
          {/* Team Info Begin */}
          <div className="team-info">
            <div className="info-front text-center">
              <h4>Nadir Ali
</h4>
              <p>CTO
</p>
            </div>
            <div className="info-back">
              <ul className="social_icon_list list-inline text-center w-100 d-flex justify-content-around">
                <li>
                  <a href="#"><i className="fab fa-facebook" aria-hidden="true" /></a>
                </li>
                <li>
                  <a href="#"><i className="fab fa-twitter" aria-hidden="true" /></a>
                </li>
                <li>
                  <a href="#"><i className="fab fa-linkedin" aria-hidden="true" /></a>
                </li>
              
              </ul>
            </div>
          </div>
          {/* Team Info End */}
        </div>
        {/* Single Team End */}
      </div>
      
     
    </div>

    <div className="row">
      <div className="col-lg-3 col-sm-6">
        {/* Single Team Begin */}
        <div className="single-team-member">
          {/* Team Image Begin */}
          <div className="image position-relative">
            <img src="././img/Unzila.jpg" alt="" />
          </div>
          {/* Team Image End */}
          {/* Team Info Begin */}
          <div className="team-info">
            <div className="info-front text-center">
              <h4>Unzila Shamim
</h4>
              <p>Head of Solutions Delivery

</p>
            </div>
            <div className="info-back">
              <ul className="social_icon_list list-inline text-center w-100 d-flex justify-content-around">
                <li>
                  <a href="#"><i className="fab fa-facebook" aria-hidden="true" /></a>
                </li>
                <li>
                  <a href="#"><i className="fab fa-twitter" aria-hidden="true" /></a>
                </li>
                <li>
                  <a href="#"><i className="fab fa-linkedin" aria-hidden="true" /></a>
                </li>
              
              </ul>
            </div>
          </div>
          {/* Team Info End */}
        </div>
        {/* Single Team End */}
      </div>
      <div className="col-lg-3 col-sm-6">
        {/* Single Team Begin */}
        <div className="single-team-member">
          {/* Team Image Begin */}
          <div className="image position-relative">
            <img src="././img/Bilal.jpg" alt="" />
          </div>
          {/* Team Image End */}
          {/* Team Info Begin */}
          <div className="team-info">
            <div className="info-front text-center">
              <h4>Syed Bilal Ali</h4>
              <p>UI/UX Developer
</p>
            </div>
            <div className="info-back">
              <ul className="social_icon_list list-inline text-center w-100 d-flex justify-content-around">
                <li>
                  <a href="#"><i className="fab fa-facebook" aria-hidden="true" /></a>
                </li>
                <li>
                  <a href="#"><i className="fab fa-twitter" aria-hidden="true" /></a>
                </li>
                <li>
                  <a href="#"><i className="fab fa-linkedin" aria-hidden="true" /></a>
                </li>
              
              </ul>
            </div>
          </div>
          {/* Team Info End */}
        </div>
        {/* Single Team End */}
      </div>
      <div className="col-lg-3 col-sm-6">
        {/* Single Team Begin */}
        <div className="single-team-member">
          {/* Team Image Begin */}
          <div className="image position-relative">
            <img src="././img/Shahzad.jpg" alt="" />
          </div>
          {/* Team Image End */}
          {/* Team Info Begin */}
          <div className="team-info">
            <div className="info-front text-center">
              <h4>Shahzad Hasan</h4>
              <p>Full Stack Developer
</p>
            </div>
            <div className="info-back">
              <ul className="social_icon_list list-inline text-center w-100 d-flex justify-content-around">
                <li>
                  <a href="#"><i className="fab fa-facebook" aria-hidden="true" /></a>
                </li>
                <li>
                  <a href="#"><i className="fab fa-twitter" aria-hidden="true" /></a>
                </li>
                <li>
                  <a href="#"><i className="fab fa-linkedin" aria-hidden="true" /></a>
                </li>
              
              </ul>
            </div>
          </div>
          {/* Team Info End */}
        </div>
        {/* Single Team End */}
      </div>
      <div className="col-lg-3 col-sm-6">
        {/* Single Team Begin */}
        <div className="single-team-member">
          {/* Team Image Begin */}
          <div className="image position-relative">
            <img src="././img/Waqas.jpg" alt="" />
          </div>
          {/* Team Image End */}
          {/* Team Info Begin */}
          <div className="team-info">
            <div className="info-front text-center">
              <h4>Waqas Irfan</h4>
              <p>Android Developer
</p>
            </div>
            <div className="info-back">
              <ul className="social_icon_list list-inline text-center w-100 d-flex justify-content-around">
                <li>
                  <a href="#"><i className="fab fa-facebook" aria-hidden="true" /></a>
                </li>
                <li>
                  <a href="#"><i className="fab fa-twitter" aria-hidden="true" /></a>
                </li>
                <li>
                  <a href="#"><i className="fab fa-linkedin" aria-hidden="true" /></a>
                </li>
              
              </ul>
            </div>
          </div>
          {/* Team Info End */}
        </div>
        {/* Single Team End */}
      </div>
      
     
    </div>

  </div>
</section>
{/* Team End */}

            
        </div>
    )
}

export default Team
